import React from "react";
import Image from "next/image";
import { Box, LinearProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

import MainHeader from "../header/MainHeader";
import CompanyLogo from "../../assets/images/leap.png";

export const StyledBox = styled(Box)(() => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  zIndex: -1,
  marginTop: "80px",
}));

export const StyledCompanyLogo = styled(Image)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
}));

const FullScreenLoader = ({ withHeader = true }) => {
  return (
    <>
      {withHeader ? <MainHeader /> : null}
      <StyledBox>
        <StyledCompanyLogo
          src={CompanyLogo}
          alt="leap.club logo"
          width="80px"
          height="80px"
        />
        <Box sx={{ width: "80px", mt: 1 }}>
          <LinearProgress />
        </Box>
      </StyledBox>
    </>
  );
};

export default FullScreenLoader;
